import React from 'react';
import { 
    TouchableOpacity, 
    View, 
    Text, 
    StyleSheet, 
    // Modal, 
    Linking, 
} from "react-native";

import Modal from './base/Modal';

// import Icon from 'react-native-ionicons';
import { Ionicons as Icon } from '@expo/vector-icons';
import { useNavigation } from '@react-navigation/native';
import FontStyles from '../../constants/FontStyle';
import Colors from '../../constants/Colors'
import StyledButton from '../StyledButton';

const VersionUpdateModal = ({ modalState, hideModal, downloadLink }) => {
    const navigation = useNavigation()
    const clickAreaRef = React.useRef()

    const gotoPlayStore = () => {
        hideModal()
        try {
            Linking.openURL(downloadLink || 'https://play.google.com/contexts/apps/details?id=com.suplias.supliasbuyer')
        } catch (e) {
            console.log(e)
        }
    }

    const handleClickOutside = e => {
        e.persist()
        if (clickAreaRef.current) {
            if (e.target === clickAreaRef.current._nativeTag) {
                hideModal()
            }
        }
    }

    return (
        <Modal
            presentationStyle='overFullScreen'
            animationType="slide"
            transparent={true}
            visible={modalState}
            onRequestClose={() => {
                hideModal()
            }}>
            <View
                ref={clickAreaRef}
                onStartShouldSetResponder={handleClickOutside}
                style={styles.overlay}
            >
                <View style={styles.container}>

                    <TouchableOpacity
                        style={styles.closeButton}
                        onPress={() => {
                            hideModal()
                        }} >
                        <Text style={styles.closeButtonText}>Close</Text>
                        <Icon name='md-close' size={24} color='#FFFFFF' />
                    </TouchableOpacity>

                    <View style={[styles.card, styles.successCard]}>

                        <Icon name='logo-android' size={57.75} color='#00A879' style={{ margin: 9.63 }} />
                        <Text style={[styles.cardBody, {
                            width: 238,
                            ...FontStyles.dark,
                            ...FontStyles.size14,
                            ...FontStyles.lh20,
                            ...FontStyles.normal,
                            textAlign: 'center',
                        }]}>An update is available. Update your app for an improved experience.</Text>

                        <StyledButton
                            style={{
                                marginTop: 28
                            }}
                            action={gotoPlayStore}
                            label='Update Now'
                        />

                    </View>

                </View>
            </View>
        </Modal>
    )
}

export default VersionUpdateModal

const styles = StyleSheet.create({
    overlay: {
        backgroundColor: 'rgba(0,0,0,0.6)',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center'
    },
    container: {
        width: '100%',
        paddingHorizontal: 16,
        justifyContent: 'center'
    },
    closeButton: {
        flexDirection: 'row',
        alignSelf: 'flex-end',
        marginBottom: 8,
        marginRight: 16,
    },
    closeButtonText: {
        color: Colors.whiteColor,
        ...FontStyles.size14,
        ...FontStyles.lh16,
        ...FontStyles.bold,
        alignSelf: 'center',
        marginRight: 8,
    },
    card: {
        borderTopLeftRadius: 25,
        borderTopRightRadius: 25,
        backgroundColor: '#FFFFFF',
        paddingHorizontal: 20,
        paddingTop: 24,
        paddingBottom: 16
    },
    successCard: {
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        borderBottomLeftRadius: 16,
        borderBottomRightRadius: 16,
        backgroundColor: '#FFFFFF',
        marginHorizontal: 16,
        alignItems: "center"
    },
    cardBody: {
        width: 288,
        ...FontStyles.bold,
        ...FontStyles.size14,
        ...FontStyles.lh20,
        ...FontStyles.normal,
    },
})